export default __webpack_public_path__ + "assets/wind-beaufort-10.31cf5854.svg";